export const authRoles = {
  sa: ["SUPER_ADMIN"], // Only Super Admin has access
  admin: ["SUPER_ADMIN", "ADMIN"], // Only SA & Admin has access
  sd: ["SUPER_ADMIN", "DEVELOPER"], // Only SA & Developer has access
  editor: ["SUPER_ADMIN", "ADMIN", "DEVELOPER"], // Only SA & Admin & Editor has access
};
